import tippy from 'tippy.js';

function calculateSize(){
	const iframeVideos = document.querySelectorAll('[data-name="iframe-video"]')

	if ( iframeVideos.length > 0 ) {
		iframeVideos.forEach(video => {
			const blockWidth = video.parentNode.offsetWidth
			const blockHeight = video.parentNode.offsetHeight

			video.style.width = blockWidth * 3 + 'px'
			video.style.height = blockHeight * 3 + 'px'
		})
	}
}

function tooltips(){
	const tooltipInstances = tippy('[data-name="tooltip-button"]', {
		trigger: 'click',
		arrow: false,
		allowHTML: true,
		theme: 'light',
		placement: 'top-start',
		content: (reference) => reference.nextElementSibling.innerHTML,
		onShow(instance) {
			const parentWidth = instance.reference.parentNode.offsetWidth - 50;
			instance.popper.style.maxWidth = `${parentWidth}px`;
		},
	});

	// Hide all tooltips on scroll
	window.addEventListener('scroll', () => {
		if (  tooltipInstances.length > 0 ) {
			tooltipInstances.forEach(instance => {
				instance.hide();
			});
		}
	}, { passive: true });
}


export default function(){
	calculateSize()
	tooltips()

	window.addEventListener('resize', calculateSize)
}

